import { page as pageIndex, globals } from '../../globals'
import {
  actionHandler,
  UPDATE_DATA
} from './updateData'

import { GET_ALL_REGIONS_FETCHED } from './regions'

import { SEARCH_LEGISLATOR_FETCHED } from './sponsorInfo'

import { saveInitialValues, clearHistory } from './undo'
import { showModal } from './modal'
import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------

export const RETURN_INITIAL_LDP = 'RETURN_INITIAL_LDP'

export const SAVE_LEGISLATOR_START = 'SAVE_LEGISLATOR_START'
export const SAVE_LEGISLATOR_SUCCESS = 'SAVE_LEGISLATOR_SUCCESS'
export const SAVE_LEGISLATOR_ERROR = 'SAVE_LEGISLATOR_ERROR'
export const SAVE_LEGISLATOR_FAILURE = 'SAVE_LEGISLATOR_FAILURE'

export const GET_LEGISLATOR_START = 'GET_LEGISLATOR_START'
export const GET_LEGISLATOR_SUCCESS = 'GET_LEGISLATOR_SUCCESS'
export const GET_LEGISLATOR_FAILURE = 'GET_LEGISLATOR_FAILURE'

export const OPEN_LEGISLATOR_RECORD = 'OPEN_LEGISLATOR_RECORD'

export const CLEAR_LEGISLATOR_START = 'CLEAR_LEGISLATOR_START'
export const CLEAR_LEGISLATOR_FAILURE = 'CLEAR_LEGISLATOR_FAILURE'

export const DELETE_LEGISLATOR_ALIAS_START = 'DELETE_LEGISLATOR_ALIAS_START'
export const DELETE_LEGISLATOR_ALIAS_SUCCESS = 'DELETE_LEGISLATOR_ALIAS_SUCCESS'
export const DELETE_LEGISLATOR_ALIAS_ERROR = 'DELETE_LEGISLATOR_ALIAS_ERROR'
export const DELETE_LEGISLATOR_ALIAS_FAILURE = 'DELETE_LEGISLATOR_ALIAS_FAILURE'

// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  'Content-Type': 'application/json'
}


export function clearLegislatorDetails(legislatorData) {
  return (dispatch) => {
    dispatch({ type: CLEAR_LEGISLATOR_START,
      payload: { json: legislatorData } })
    .catch((err) => {
    console.log(err)
      dispatch({ type: CLEAR_LEGISLATOR_FAILURE })
    })
  }
}

export function deleteLegislatorAlias(legislatorData, aliasId){
  let xx = legislatorData;
  let yy = aliasId;
  return (dispatch) => {
    dispatch({ type: DELETE_LEGISLATOR_ALIAS_START })
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/sponsorreview/LegislatorAlias?referencelegislatoraliasid=${aliasId}`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: DELETE_LEGISLATOR_ALIAS_SUCCESS,
          payload: {
            aliasId
          }
        })
        //dispatch(openLegislatorRecord(legislatorData.legislatorId, legislatorData));
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_LEGISLATOR_ALIAS_FAILURE })
    })
  }  
}

// Create or update a ReferenceLegislator depending on 
// legislatorCM.ReferenceLegislatorId being populated. 
export function addLegislatorToStore (legislatorData, trackData, id) {
  return (dispatch) => {
    dispatch({ type: SAVE_LEGISLATOR_START })
    const baseData = legislatorData.baseData;
    const legislatorCM = {
      ReferenceLegislatorId: baseData.legislatorId, 
      RegionCode: baseData.radio.state, 
      FirstName: baseData.textValues.firstName, 
      LastName: baseData.textValues.lastName, 
      Chamber: baseData.radio.chamber, 
      StartYear: baseData.textValues.startYear, 
      EndYear: baseData.textValues.endYear, 
      Title: baseData.radio.title, 
      Party: baseData.radio.politicalParty, 
      Active: baseData.radio.isactive == "true", 
      Homepage: baseData.textValues.url, 
    }
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(legislatorCM)
    }
    fetch(`${globals.apiUrl}/sponsorreview/legislator`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 409 || response.status === 400) {
        return response.text().then((text) => {
          dispatch({
            type: SAVE_LEGISLATOR_ERROR,
            errorMessage: text
          })
          dispatch(showModal('Error-raw-legislator-data-message'))
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: SAVE_LEGISLATOR_SUCCESS,
          payload: {
            json
          }
        })
        dispatch(clearHistory(pageIndex.legislatorData))
        dispatch(saveInitialValues(pageIndex.legislatorData, trackData))
        if (json.ReferenceLegislatorId) {
          dispatch(openLegislatorRecord(json.ReferenceLegislatorId, trackData));
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: SAVE_LEGISLATOR_FAILURE })
    })
  }
}


export function returnInitialState () {
  return {
    type: RETURN_INITIAL_LDP
  }
}


export function openLegislatorRecord(id, trackData) {
  return (dispatch) => {
    dispatch({ type: GET_LEGISLATOR_START })
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/sponsorreview/legislatorplus?legislatorid=${id}&`,
    options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_LEGISLATOR_SUCCESS,
          payload: {
            legislatorData: json
          }
        })
        dispatch(clearHistory(pageIndex.legislatorData))
        const legislatorData = {
          baseData: {
            radio: {
              state: json.RegionCode,
              chamber: json.Chamber,
              politicalParty: json.Party,
              title: json.Title,
              isactive: json.Active ? "true" : "false",
            },
            textValues: {              
              firstName: json.FirstName,
              lastName: json.LastName,
              url: json.Homepage ? json.Homepage : '',
              homepage: json.Homepage ? json.Homepage : '',
              startYear: json.StartYear,
              endYear: json.EndYear,
              searchName: trackData.baseData.textValues.searchName, 
            },
            legislatorId: json.ReferenceLegislatorId,
            aliases: json.Aliases ? json.Aliases : [],
          }
        }
        dispatch(saveInitialValues(pageIndex.legislatorData, legislatorData))
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: GET_LEGISLATOR_FAILURE })
    })
  }
}

const returnDateFormat = (date) => {
  return date && date !== ' ' ? moment(date).format('MMM / DD / YYYY') : ' '
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA] : (state, action) => action.location.page !== pageIndex.legislatorData
    ? state : actionHandler(state, action),
  [SAVE_LEGISLATOR_SUCCESS] : (state, action) => {
    const { legislatorData } = action.payload.json;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        legislatorRecordSaved: true,
        rawBillDataQueue: [],
        rawLegislatorRecord: legislatorData,
      },
      formDataValue: {
        LDP: {
          ...state.formDataValue.LDP,
          legislatorId: action.payload.json.ReferenceLegislatorId,
        }
      }
    }
  },
  [SAVE_LEGISLATOR_ERROR] : (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        legislatorRecordSaved: false,
        errorMessage: action.errorMessage
      }
    }
  },
  [RETURN_INITIAL_LDP] : () => {
    return {
      ...initialState
    }
  },
  [CLEAR_LEGISLATOR_START] : (state, action) => {
    const { id } = action
    const { record } = action.payload.json.legislatorData;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        rawLegislatorRecord: action.payload.legislatorData
      },
      formDataValue: {
        // LDP
        LDP: {
          ...state.formDataValue.LDP,
          baseData: {
            ...state.formDataValue.LDP.baseData,
            radio: {            
              ...state.formDataValue.LDP.baseData.radio,  
              //state: action.payload.legislatorData.RegionCode,
              chamber: '',
              politicalParty: '',
              title: '',
              isactive: '',
            },
            textValues: {
              ...state.formDataValue.LDP.baseData.textValues,           
              firstName: '',
              lastName: '',
              url: '',
              homepage: '',
              startYear: '',
              endYear: '',
            },
            legislatorId: 0,
            aliases: [],
          }
        }
      }
    }
  },
  [GET_LEGISLATOR_SUCCESS] : (state, action) => {
    const { id } = action
    const { record } = action.payload.legislatorData;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        rawLegislatorRecord: action.payload.legislatorData
      },
      formDataValue: {
        // LDP
        LDP: {
          ...state.formDataValue.LDP,
          // navigation: {
          //   id: action.payload.legislatorData.id,
          // },
          baseData: {
            ...state.formDataValue.LDP.baseData,
            radio: {              
              state: action.payload.legislatorData.RegionCode,
              chamber: action.payload.legislatorData.Chamber,
              politicalParty: action.payload.legislatorData.Party,
              title: action.payload.legislatorData.Title,
              isactive: action.payload.legislatorData.Active ? "true" : "false",
            },
            textValues: {
              ...state.formDataValue.LDP.baseData.textValues,           
              firstName: action.payload.legislatorData.FirstName,
              lastName: action.payload.legislatorData.LastName,
              url: action.payload.legislatorData.Homepage ? action.payload.legislatorData.Homepage : '',
              homepage: action.payload.legislatorData.Homepage ? action.payload.legislatorData.Homepage : '',
              startYear: action.payload.legislatorData.StartYear,
              endYear: action.payload.legislatorData.EndYear,
            },
            legislatorId: action.payload.legislatorData.ReferenceLegislatorId,
            aliases: action.payload.legislatorData.Aliases 
            ? action.payload.legislatorData.Aliases : [],
          }
        }
      }
    }
  },
  [DELETE_LEGISLATOR_ALIAS_SUCCESS]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
      },
      formDataValue: {
        // LDP
        LDP: {
          ...state.formDataValue.LDP,
          baseData: {
            ...state.formDataValue.LDP.baseData,
            aliases: state.formDataValue.LDP.baseData.aliases  
            ? state.formDataValue.LDP.baseData.aliases.filter(x => x.ReferenceLegislatorAliasId != action.payload.aliasId) : [],
          }
        }
      }
    }
  },

  [GET_ALL_REGIONS_FETCHED]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        legislatorStates: action.payload.json.map((item) => {
          return {
            value: item.ShortName,
            label: item.Name,
          };
        }).filter((elem) => {
          return elem.label !== "All States" 
            && elem.label !== "Canada"
            && elem.label !== "Spain"
        }),
      },
    };
  },
  [SEARCH_LEGISLATOR_FETCHED] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        legislatorResults: json
      }
    }
  },
}
// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  isFetchingData: false,
  errorCode: '',
  renderData: {
    errorMessage: '',
    billRecordSaved: false,
    rawBillDataQueue: [{
      RawFileId: 0,
      State: null,
      BillType: null,
      Session: null,
      PrefileYear: null,
      BillNumber: null,
      Introdate: ' ',
      SponsorFirstName: null,
      Sponsor: null,
      Url: null,
      Summary: null,
      History: null,
      disableEditing: false
    }],
    rawBillRecord: {
      RawFileId: 0
    }
  },
  formDataValue: {
    LDP: {
      navigation: {
        textValues: {
          currentRecord: '1'
        }
      },
      baseData: {
        radio: {
          state: '',
          chamber: '',
          politicalParty: '',
          title: '',
          isactive: '',
        },
        textValues: {          
          firstName: '',
          lastName: '',
          url: '',
          startYear: '',
          endYear: '',
          searchName: '',
        },
        legislatorId: 0,
        aliases: [],
      },
    }
  }
}
export default function legislatorDataReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/legislatorFormData.js